export default "__VITE_ASSET__4ZxUzk3$__";